module.exports = __webpack_public_path__ + "static/img/2-17-错发退货退款商品库.c84eb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-17-错发退货退款商品库.png
// module id = 1352
// module chunks = 0